<template src="./download.html"></template>

<script>
import { get_download } from "@/api/api.download.js";

export default {
  data: function () {
    return {
      dati: [],

      defaultTab: null,
      search: "",
    };
  },

  methods: {
    compare(a, b) {
      if (a.UltimaModifica > b.UltimaModifica) {
        return -1;
      }
      if (a.UltimaModifica < b.UltimaModifica) {
        return 1;
      }
      return 0;
    },

    async caricaDati() {
      // Reset
      this.dati = [];

      let res = await get_download();
      this.dati = res.data;
      //ordino i file per ultima modifica
      this.dati[1].SottoCartelle[0].Files.sort(this.compare);
      // Controllo x selezionare la prima tab
      if (this.dati[0]) this.defaultTab = "tab-" + this.dati[0].Descrizione;
    },

    scaricaFile(src) {
      window.open(src, "_blank");
    },

    filterResult(items) {
      var self = this;

      return items.filter(function (person) {
        return (
          person.Descrizione.toLowerCase().indexOf(self.search.toLowerCase()) >=
          0
        );
      });
    },

    NovitaFile(file) {
      let nuovo = false;

      if (this.$i2kFunctions.dateDiffDay(file.UltimaModifica, new Date()) <= 15)
        nuovo = true;
      return nuovo;
    },
  },

  mounted: async function () {
    //aspetto qualche millisecondo cosi vue carica i dati dell'utente nello storage
    await this.$functions.delay(500);
    this.caricaDati();
  },
};
</script>




